/**
 * @fileoverview Tenant activity history query hook.
 * @description Wraps GET /sales/tenants/:id/activities in a TanStack query. Disabled while
 * `tenantId` is falsy, same reasoning as useTenant.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useQuery } from '@tanstack/react-query'

import { getTenantActivities } from '@/features/sales/services/tenant-activities.service'

export const TENANT_ACTIVITIES_QUERY_KEY = (tenantId: string) => [
  'sales',
  'tenants',
  tenantId,
  'activities',
]

/**
 * @description Fetches a tenant's full activity history, oldest first.
 * @param {string} tenantId - The tenant id to fetch activities for, or an empty string to keep the
 * query disabled.
 * @returns {ReturnType<typeof useQuery>} The query object (data, isPending, error, ...).
 */
export function useTenantActivities(tenantId: string) {
  return useQuery({
    queryKey: TENANT_ACTIVITIES_QUERY_KEY(tenantId),
    queryFn: () => getTenantActivities(tenantId),
    enabled: tenantId !== '',
  })
}
